/* GO blog listing: keyword search + sort over the ?view=go-index article index.
   Server-rendered pagination is left alone unless a search term or oldest-first sort is active. */
(function () {
	const root = document.querySelector('[data-go-blog]');
	if (!root) return;

	const perPage = parseInt(root.dataset.perPage, 10) || 8;
	const input = root.querySelector('[data-go-blog-input]');
	const form = root.querySelector('[data-go-blog-search]');
	const sortSelect = root.querySelector('[data-go-blog-sort]');
	const count = root.querySelector('[data-go-blog-count]');
	const current = root.querySelector('[data-go-blog-current]');
	const term = root.querySelector('[data-go-blog-term]');
	const results = root.querySelector('[data-go-blog-results]');
	const empty = root.querySelector('[data-go-blog-empty]');
	const pagination = root.querySelector('[data-go-blog-pagination]');
	let index = null;

	const readState = () => {
		const p = new URLSearchParams(location.search);
		return {
			q: (p.get('q') || '').trim(),
			sort: p.get('sort') === 'oldest' ? 'oldest' : 'newest',
			page: Math.max(1, parseInt(p.get('page'), 10) || 1),
		};
	};

	const buildUrl = (base, state) => {
		const p = new URLSearchParams();
		if (state.q) p.set('q', state.q);
		if (state.sort === 'oldest') p.set('sort', 'oldest');
		if (state.page > 1) p.set('page', state.page);
		const qs = p.toString();
		return base + (qs ? '?' + qs : '');
	};

	const loadIndex = () => {
		if (!index) {
			const getPage = (n) =>
				fetch(`${root.dataset.indexUrl}&page=${n}`, { credentials: 'same-origin' })
					.then((r) => r.text())
					.then((t) => JSON.parse(t));
			index = getPage(1).then((first) => {
				const rest = [];
				for (let n = 2; n <= first.pages; n++) rest.push(getPage(n));
				return Promise.all(rest).then((more) => more.reduce((all, p) => all.concat(p.items), first.items));
			});
		}
		return index;
	};

	const pageList = (page, pages) => {
		const out = [];
		for (let i = 1; i <= pages; i++) {
			if (i === 1 || i === pages || Math.abs(i - page) <= 2) out.push(i);
			else if (out[out.length - 1] !== '…') out.push('…');
		}
		return out;
	};

	const renderPagination = (state, pages) => {
		const base = root.dataset.listingUrl;
		const link = (page, label, aria) =>
			`<a href="${buildUrl(base, { ...state, page })}" class="go-blog__page" data-page="${page}" aria-label="${aria}">${label}</a>`;
		let html = '';
		if (pages > 1 && state.page > 1) html += link(state.page - 1, '&larr;', 'Previous page');
		pageList(state.page, pages).forEach((n) => {
			if (n === '…') html += '<span class="go-blog__page">&hellip;</span>';
			else if (n === state.page) html += `<span class="go-blog__page is-current" aria-current="page">${n}</span>`;
			else html += link(n, n, 'Page ' + n);
		});
		if (pages > 1 && state.page < pages) html += link(state.page + 1, '&rarr;', 'Next page');
		pagination.innerHTML = pages > 0 ? html : '';
	};

	const syncTopicLinks = (state) => {
		root.querySelectorAll('[data-go-blog-topic]').forEach((a) => {
			const base = a.getAttribute('href').split('?')[0];
			a.setAttribute('href', buildUrl(base, { ...state, page: 1 }));
		});
	};

	const render = (state) => {
		input.value = state.q;
		sortSelect.value = state.sort;
		syncTopicLinks(state);
		current.hidden = !state.q;
		term.textContent = state.q;

		if (!state.q && state.sort === 'newest' && !root.classList.contains('go-blog--client')) {
			root.classList.remove('go-blog--pending');
			return Promise.resolve();
		}

		return loadIndex()
			.then((items) => {
				const words = state.q.toLowerCase().split(/\s+/).filter(Boolean);
				let list = items.filter((a) => words.every((w) => a.s.includes(w)));
				list.sort((a, b) => (state.sort === 'oldest' ? a.t - b.t : b.t - a.t));

				const pages = Math.ceil(list.length / perPage);
				if (state.page > pages) state.page = Math.max(1, pages);
				const start = (state.page - 1) * perPage;
				const slice = list.slice(start, start + perPage);

				let grid = results.querySelector('[data-go-blog-grid]');
				if (!grid) {
					grid = document.createElement('ul');
					grid.className = 'go-blog__grid';
					grid.setAttribute('role', 'list');
					grid.setAttribute('data-go-blog-grid', '');
					results.prepend(grid);
				}
				grid.innerHTML = slice.map((a) => `<li>${a.h}</li>`).join('');
				grid.hidden = slice.length === 0;
				empty.hidden = slice.length > 0;
				count.textContent = list.length
					? `Showing ${start + 1} to ${start + slice.length} of ${list.length} articles`
					: '0 articles found';
				renderPagination(state, pages);
				root.classList.add('go-blog--client');
			})
			.catch(() => {
				// Index failed to load: fall back to the server-rendered listing.
			})
			.finally(() => root.classList.remove('go-blog--pending'));
	};

	const go = (state, scroll) => {
		history.pushState(null, '', buildUrl(root.dataset.listingUrl, state));
		render(state).then(() => {
			if (scroll) root.querySelector('.go-blog__topics').scrollIntoView({ behavior: 'smooth', block: 'start' });
		});
	};

	form.addEventListener('submit', (e) => {
		e.preventDefault();
		go({ ...readState(), q: input.value.trim(), page: 1 }, false);
	});

	// Emptying the box (typing it out or the clear button) drops back to every article without pressing Search.
	input.addEventListener('input', () => {
		if (!input.value.trim() && readState().q) go({ ...readState(), q: '', page: 1 }, false);
	});

	sortSelect.addEventListener('change', () => {
		go({ ...readState(), sort: sortSelect.value, page: 1 }, false);
		sortSelect.blur();
	});

	root.addEventListener('click', (e) => {
		const clear = e.target.closest('[data-go-blog-clear]');
		if (clear) {
			e.preventDefault();
			go({ ...readState(), q: '', page: 1 }, false);
			input.focus();
			return;
		}
		const page = e.target.closest('[data-go-blog-pagination] a[data-page]');
		if (page && root.classList.contains('go-blog--client')) {
			e.preventDefault();
			go({ ...readState(), page: parseInt(page.dataset.page, 10) }, true);
		}
	});

	window.addEventListener('popstate', () => render(readState()));

	render(readState());
})();
